<template>
    <div dir="rtl">
        <!-- .body-wrapper is what every page uses to clear the fixed top header;
             without it the tab bar renders underneath it. -->
        <div class="body-wrapper pb-0">
            <div class="container-fluid">
            <div class="fin-hub-head">
                <div>
                    <h5 class="fin-hub-title">المالية</h5>
                    <small class="fin-hub-sub">نفس السجل المالي — التبويب يحدد ما تفعله به</small>
                </div>
                <div class="fin-hub-tabs">
                    <button type="button"
                            class="fin-hub-tab"
                            :class="{ active: tab === 'withdraw' }"
                            @click="setTab('withdraw')">
                        <iconify-icon icon="solar:card-recive-line-duotone"></iconify-icon>
                        طلبات السحب — اعتماد / رفض
                    </button>
                    <button type="button"
                            class="fin-hub-tab"
                            :class="{ active: tab === 'manual' }"
                            @click="setTab('manual')">
                        <iconify-icon icon="solar:pen-new-square-line-duotone"></iconify-icon>
                        القيود المالية اليدوية
                    </button>
                </div>
                </div>
            </div>
        </div>

        <!-- Only the active tab is mounted, so each page still runs its own
             created()/fetch exactly once — no double request, no shared state. -->
        <Withdrawing v-if="tab === 'withdraw'" key="withdraw" />
        <Financial v-else key="manual" />
    </div>
</template>

<script>
/**
 * /Financial and /FinancialWithdrawing hit the SAME endpoint
 * (Financial/GetWithdrawingTracker) with the same eight arguments — they only
 * differ in which actions the UI exposes: approve/reject a withdraw request vs
 * add/edit a manual financial entry. Two menu entries for one dataset was a
 * large part of "القائمة غير مفهومة", so they are now one page with two tabs.
 *
 * Both legacy routes still resolve here: /FinancialWithdrawing opens the
 * withdraw tab, /Financial?tab=manual opens the manual-entry tab, so old
 * bookmarks keep working.
 */
import Withdrawing from './Withdrawing/Withdrawing.vue';
import Financial from './Financial.vue';

export default {
    name: 'FinancialHub',
    components: { Withdrawing, Financial },

    data() {
        return { tab: 'withdraw' };
    },

    created() {
        this.tab = this.resolveTab();
    },

    watch: {
        '$route'() {
            this.tab = this.resolveTab();
        }
    },

    methods: {
        resolveTab() {
            const q = (this.$route.query.tab || '').toLowerCase();
            if (q === 'manual' || q === 'withdraw') return q;
            // No explicit query: /Financial historically WAS the manual-entry
            // ledger, so keep that meaning for direct hits on that path.
            return this.$route.path.toLowerCase() === '/financial' ? 'manual' : 'withdraw';
        },

        setTab(tab) {
            if (this.tab === tab) return;
            this.tab = tab;
            if ((this.$route.query.tab || '') !== tab) {
                this.$router.replace({ path: this.$route.path, query: { tab } }).catch(() => { });
            }
        }
    }
};
</script>

<style scoped>
.fin-hub-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    background: #fff;
    border: 1px solid rgba(15, 23, 42, .06);
    border-radius: 16px;
    padding: 14px 18px;
    box-shadow: 0 12px 30px rgba(15, 23, 42, .05);
}

.fin-hub-title {
    font-weight: 900;
    color: #0f172a;
    margin: 0;
}

.fin-hub-sub {
    color: #64748b;
}

.fin-hub-tabs {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.fin-hub-tab {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 1px solid rgba(15, 23, 42, .08);
    background: #f8fafc;
    color: #0f172a;
    font-weight: 800;
    font-size: 13px;
    padding: 9px 16px;
    border-radius: 12px;
    cursor: pointer;
    transition: background .15s ease, color .15s ease, border-color .15s ease;
}

.fin-hub-tab:hover {
    border-color: #5d87ff;
    color: #5d87ff;
}

.fin-hub-tab.active {
    background: #5d87ff;
    border-color: #5d87ff;
    color: #fff;
}
</style>
